import { PLATFORM_URL } from "app/constants/variables";
import request from "../request";
import { GenericResponse } from "../types";
import { ListPairsParams, TradePair } from "./types";

export const listPairs = (token: string, { publicKey, ...params }: ListPairsParams) => {
    return request.get<GenericResponse<TradePair[]>>("v1/pairs", {
        baseURL: PLATFORM_URL,
        headers: {
            Authorization: `Bearer ${token}`,
            ...(publicKey && { 'X-BU-PUBLIC-KEY': publicKey })
        },
        params: params,
    });
};